import * as Sentry from '@sentry/vue'
import type { TracingOptions } from '@sentry/vue/build/types/types'
import { isEmpty } from 'lodash'
import type { App } from 'vue'

export const initSentry = () => {
  const dsn = window.__GLOBAL__.sentryDsn

  if (isEmpty(dsn)) {
    // eslint-disable-next-line no-console
    console.warn('Sentry DSN is not set. Cannot init!')

    return
  }

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', `https://${window.Shopify.shop}`],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })

  Sentry.getGlobalScope().setExtra('Shopify', window.Shopify)

  // eslint-disable-next-line no-console
  console.log('Sentry initialized successfully!')
}

export const applySentryToVueApp = (app: App) => {
  const traceOptions: Partial<TracingOptions> = {
    trackComponents: true,
    timeout: 1000,
    hooks: ['activate', 'create', 'unmount', 'mount', 'update']
  }

  app.mixin(Sentry.createTracingMixins(traceOptions))
  Sentry.attachErrorHandler(app, {
    ...traceOptions,
    attachProps: true,
    attachErrorHandler: true
  })
}
